import ThemeMui from '@digital-hig/theme-mui';
import Button from '@digital-hig/button';
import {default as TextLinkDhig} from '@digital-hig/text-link';
import '../UniversalHelp/_UniversalHelp.scss';

const ConfirmModal = ({
  handleYes,
  handleNo,
  handleSaveChat,
  title,
  body,
  confirmText,
  rejectText,
  saveChatText,
}) => {
  return (
    <div className="confirm-modal-container" data-testid="uh-modal">
      <div className="confirm-modal-content">
        <h3>{title}</h3>
        <p>{body}</p>
        <ThemeMui>
            <div className="confirm-modal-buttons">
              <Button
                variant="contained"
                onClick={() => handleYes()}
                data-testid="confirm-button"
              >
                {confirmText}
              </Button>
              <Button
                variant="outlined"
                onClick={() => handleNo()}
                data-testid="reject-button"
              >
                {rejectText}
              </Button>
            </div>
            {saveChatText && (
              <div className="confirm-modal-save-chat-button">
                <TextLinkDhig
                  onClick={() => handleSaveChat()}
                  data-testid="save-chat-button"
                >
                  {saveChatText}
                </TextLinkDhig>
              </div>
            )}
        </ThemeMui>
      </div>
    </div>
  );
};

export default ConfirmModal;
